<app-auditable-lookups
  [paginationResponseResolver]="client"
  [defaultPaginationParameters]="defualtPaginationParameters"
  [supportedActions]="supportedActions"
  [tableConfig]="{
    fields: [
      { name: 'description', displayName: 'GENERAL.DESCRIPTION' },
      { name: 'country.englishName', displayName: 'GENERAL.COUNTRY' }
    ],
    template: tableRowTemplate
  }"
/>

<ng-template #tableRowTemplate let-element>
  <td>{{ element.description }}</td>
  <td>{{ element.country.englishName }}</td>
</ng-template>
